import { useState ,useEffect  } from "react";
import { Routes, Route } from "react-router-dom";
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";
import Dashboard from "./scenes/dashboard";
import Team from "./scenes/team";
import Report from "./scenes/report";
import Contacts from "./scenes/contacts";
import Bar from "./scenes/bar";
import Form from "./scenes/form";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import FAQ from "./scenes/faq";
import Geography from "./scenes/geography";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Calendar from "./scenes/calendar/calendar";
import LoginPage from "./LoginPage"
import CrudPage from './scenes/crud';
import { useNavigate } from 'react-router-dom';
import MVU from './scenes/mvu'
import ExcelToDataGrid from "./scenes/mvu/ExcelToDataGrid";
import { useParams } from 'react-router-dom';
import ExcelUploader from "./components/ExcelUploader";
import ProductList from "./scenes/products";
import ProductForm from "./scenes/products/add";
import ProductDetailsPage from "./scenes/products/details";
import SalesList from "./scenes/sales";
import SalesDetailsPage from "./scenes/sales/details";
import Brands from "./scenes/brands";
import BrandDetails from "./scenes/brands/details";
import UISettings from "./scenes/uiSettings";
import Categories from "./scenes/categories";
import CategoryDetails from "./scenes/categories/details";
import BannersList from "./scenes/banners";
import BannerDetails from "./scenes/banners/details";
function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const [isAuthenticated,setIsAuthenticated] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUsername = sessionStorage.getItem("isAuthenticated");
    if (storedUsername=='yes') {
      setIsAuthenticated(true);
    }
  },[isAuthenticated]);
  
  const CrudWrapper = () => {
    const { model } = useParams();
    return <CrudPage key={model} />;
};

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
        { 
        !isAuthenticated &&
        <Routes>
        <Route path="/*" element={<LoginPage callBack={()=>{
          setIsAuthenticated(true)
          sessionStorage.setItem("isAuthenticated", 'yes');
        }
          }/>} />
        </Routes>
      }
      {
         isAuthenticated && <>
          <Sidebar isSidebar={isSidebar} />
          <main className="content" >
            {/* <Topbar setIsSidebar={setIsSidebar} /> */}
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/logout" element={<Dashboard callBack={()=>{
                  setIsAuthenticated(false)
                  sessionStorage.removeItem("isAuthenticated");
                  navigate('/');
            }
          }/>} />
              <Route path="/products" element={<ProductList />} />
              <Route path="/products/add" element={<ProductForm/>} />
              <Route path="/products/edit/:id" element={<ProductForm/>} />
              <Route path="/products/:id" element={<ProductDetailsPage />} />
              <Route path="/discounted-sale" element={<SalesList />} />
              <Route path="/discounted-sale/:id" element={<SalesDetailsPage />} />
              <Route path="/brands" element={<Brands />} />
              <Route path="/brands/:id" element={<BrandDetails />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="/categories/:id" element={<CategoryDetails />} />
              <Route path="/banners" element={<BannersList />} />
              <Route path="/banners/:id" element={<BannerDetails />} />
              <Route path="/contacts" element={<Contacts />} />
              <Route path="/report/:model" element={<Report />} />
              <Route path="/mvu" element={<MVU />} />

              <Route path="/excel" element={<ExcelToDataGrid />} />
              <Route path="/form" element={<Form />} />
              <Route path="/bar" element={<Bar />} />
              <Route path="/pie" element={<Pie />} />
              <Route path="/line" element={<Line />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/calendar" element={<Calendar />} />
              <Route path="/geography" element={<Geography />} />
              <Route path="/crud/:model/" element={<CrudWrapper />} />
              <Route path="/crud/:model/:submodel" element={<CrudPage/>} />
              <Route path="/dataupload" element={<ExcelUploader/>} />
              <Route path="/ui-settings" element={<UISettings />} />

            </Routes>
          </main>
          </>
    }
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}
export default App;
